import { useState, useMemo } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessFileDisplayModal from "./ProcessFileDisplayModal";
import processApi from "../../api/processApi";

import { getLabel, getLanguage } from "../../tools/Dictionary";

import "./ProcessFile.css";

const ProcessFileDisplay = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Data = props.Data;
  const Type = useMemo(() =>
  {
    if (props.Data && props.Data.type && props.Data.type.substring(0, 5) == "image") return "image";
    if (props.Data && props.Data.type && props.Data.type.substring(0, 5) == "video") return "video";
    if (props.Data && props.Data.type && props.Data.type == "application/pdf") return "pdf";
    else return "other"

  }, [props.Data]);

  //State
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onDownload = async () =>
  {

    try
    {

      setLoading(true);



      let response = await processApi.downloadProcessFile(Data._id);


      const blob = new Blob([response], {
        type: 'application/octet-stream'
      });



      let url = URL.createObjectURL(blob);

      // Create an anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = Data.name + "." + Data.format;

      // Append the anchor element to the document body
      document.body.appendChild(a);

      // Programmatically trigger a click event on the anchor element to initiate the download
      a.click();

      // Cleanup: Remove the anchor element and revoke the temporary URL
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      setLoading(false);


    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  const onClickLink = async() => {


    try{

      if (Type == "image" || Type == "pdf"){
        setModal(true);
      } else onDownload();
        

    }catch(err){
      
    }

  };

  

  if (!Data) return null;

  return (
    <div className="processfile_display_cont">
      {modal &&
        <ProcessFileDisplayModal
          Data={Data}
          Type={Type}
          OnCloseModal={() => setModal(false)}
        />
      }
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      {Data && Data.label &&  
        <div className="processfile_display_row_url" onClick={onClickLink}>
          {Data.label[getLanguage().code] || Data.label["EN"] || ""}.{Data.format}
        </div>
      }
    </div>
  );

};

export default ProcessFileDisplay